module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('NavBar', [_c('div', {
    staticClass: "main"
  }, [_c('div', {
    staticClass: "row",
    attrs: {
      "id": "present-row"
    }
  }), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "tab-row"
  }, [_c('a', {
    class: {
      'active': _vm.currentTab == 'present'
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.currentTab = 'present'
      }
    }
  }, [_vm._v("分析报告")]), _c('a', {
    class: {
      'active': _vm.currentTab == 'account'
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.currentTab = 'account'
      }
    }
  }, [_vm._v("账户优化")])])]), (_vm.currentTab !== 'present') ? _c('div', {
    staticClass: "row"
  }, [_c('table', {
    staticClass: "account"
  }, _vm._l((_vm.accountItems), function(item, index) {
    return _c('tr', [_c('td', {
      staticClass: "cell"
    }, [_c('div', {
      staticClass: "manual-text",
      attrs: {
        "data-index": index + 1
      }
    }, [_vm._v(_vm._s(item.title))]), _c('div', {
      staticClass: "desc"
    }, [(item.context) ? _c('span', {
      staticClass: "text"
    }, [_vm._v(_vm._s(item.context))]) : _vm._e(), (item.des.length > 0) ? _c('ol', {
      staticClass: "sub-text"
    }, [(item.context) ? _c('li') : _vm._e(), _vm._l((item.des), function(des, desIndex) {
      return _c('li', [_c('span', {
        staticClass: "text"
      }, [_vm._v(_vm._s(des.text))])])
    })], 2) : _vm._e(), (item.notice) ? _c('span', {
      staticClass: "tag-notice"
    }, [_vm._v("注意：" + _vm._s(item.notice))]) : _vm._e()])]), _c('td', {
      staticClass: "cell img-cell txt-right",
      class: {
        'pt20': index == 0
      }
    }, [_c('img', {
      attrs: {
        "src": item.img
      }
    })])])
  }))]) : _vm._l((_vm.presentItems), function(item, index) {
    return _c('div', {
      staticClass: "row"
    }, [_c('table', {
      staticClass: "present"
    }, [_c('tr', [(index % 2 !== 0) ? _c('td', {
      staticClass: "cell txt-left"
    }, [_c('img', {
      attrs: {
        "src": item.img
      }
    })]) : _vm._e(), _c('td', {
      staticClass: "cell"
    }, [_c('div', {
      staticClass: "title"
    }, [_vm._v(_vm._s(item.title))]), _vm._l((item.des), function(des) {
      return _c('div', {
        staticClass: "des"
      }, [_c('div', {
        staticClass: "subtitle"
      }, [_vm._v(_vm._s(des.subtitle))]), _c('div', {
        staticClass: "text"
      }, [_vm._v(_vm._s(des.text))])])
    })], 2), (index % 2 === 0) ? _c('td', {
      staticClass: "cell txt-right"
    }, [_c('img', {
      attrs: {
        "src": item.img
      }
    })]) : _vm._e()])])])
  })], 2)]), _c('div', {
    staticClass: "ft"
  }, [_vm._m(0), _c('site-footer')], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "footer-container"
  }, [_c('div', {
    staticClass: "little-person"
  })])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-d40e97e8", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-d40e97e8!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pageview/present.vue
// module id = 800
// module chunks = 0